import { H4, HorizontalRule } from '@snsw/react-component-library';
import { PlantDesignDesignerVerifierPage } from 'plantDesign/constants/plantDesignDesignerVerifierPage';
import React from 'react';
import { capitalizeFirstLetter } from 'shared/utils/Helpers';
import { mapDesignerOrVerifierSummary } from 'plantDesign/utils/PlantDesignSummaryFormatHelper';
import styles from '../PlantDesignReview.module.scss';

export const DesignerAndDesignVerifierReview = (props) => {
  const { designerAndDesignVerifierDetails = {} } = props;
  const { designerDetails, verifierDetails, uploadedDocument } = designerAndDesignVerifierDetails;

  const isDesigner = (isDesigner) => {
    return [
      {
        text: PlantDesignDesignerVerifierPage.areYouDesignerLabel,
        value: capitalizeFirstLetter(isDesigner),
      },
    ];
  };

  const renderDetails = (details) => {
    return details.map(
      (prop) =>
        prop.value && (
          <div key={prop.text}>
            <div className={styles.summaryLabel}>{prop.text}</div>
            <div className={styles.summaryValue}>{prop.value}</div>
          </div>
        ),
    );
  };

  return (
    <>
      {renderDetails(isDesigner(designerAndDesignVerifierDetails.isDesigner))}
      <br></br>
      {designerAndDesignVerifierDetails.isDesigner === 'no' && (
        <>
          <H4>Designer details</H4>
          {renderDetails(mapDesignerOrVerifierSummary(designerDetails))}
        </>
      )}
      {verifierDetails && (
        <>
          <H4 className={styles.summaryLabel}>Design Verifier details</H4>
          {renderDetails(mapDesignerOrVerifierSummary(verifierDetails))}
        </>
      )}

      {/* TODO: Use ListView Component */}
      <H4 className={styles.summaryLabel}>Designer and Design Verifier statement</H4>
      <HorizontalRule className={styles.horizontalRule} />
      <div className={styles.listViewDetailsValue}>Uploaded statement</div>

      {uploadedDocument?.map((file) => (
        <div key={file.id}>{file.name}</div>
      ))}
      <br></br>
    </>
  );
};
